// extracted by mini-css-extract-plugin
module.exports = {"blogSectionWrap":"home_blogSectionWrap__nh_Qu","blogSection":"home_blogSection__1O3Ku","blogButton":"home_blogButton__HnKlN"};